import {IPFS_HASH} from 'decentralized/EthereumDataTypes.js';
import {INT_8} from 'decentralized/EthereumDataTypes.js';
import {INT_16} from 'decentralized/EthereumDataTypes.js';
import {INT_32} from 'decentralized/EthereumDataTypes.js';
import {UINT_256} from 'decentralized/EthereumDataTypes.js';
import {RIGHT_PADDED_BYTES_32} from 'decentralized/EthereumDataTypes.js';
import {BYTES_32, BYTES_32_LEFT} from 'decentralized/EthereumDataTypes.js';
import {BYTES_32_ENCRYPTED} from 'decentralized/EthereumDataTypes.js';
import {BYTES_32_ARRAY} from 'decentralized/EthereumDataTypes.js';
import {NOTE_BYTES_32} from 'decentralized/EthereumDataTypes.js';
import {NOTES_BYTES_32} from 'decentralized/EthereumDataTypes.js';
import {ADDRESS} from 'decentralized/EthereumDataTypes.js';
import {STRING} from 'decentralized/EthereumDataTypes.js';

import EthereumEventLog from 'decentralized/EthereumEventLog.js';
import EthereumTopic from 'decentralized/EthereumTopic.js';

export const SampleTagged = new EthereumEventLog(
    'SampleTagged(bytes32,bytes32,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('tag', BYTES_32),
     new EthereumTopic('guildId', INT_32)
    ]);

 export const SampleStyle = new EthereumEventLog(
    'SampleStyle(bytes32,bytes32,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('style', BYTES_32),
     new EthereumTopic('guildId', INT_32)
    ]);
                                                 
 export const SampleYear = new EthereumEventLog(
    'SampleYear(bytes32,int16,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('year', INT_16),
     new EthereumTopic('guildId', INT_32)
    ]);

export const SampleCountry = new EthereumEventLog(
    'SampleCountry(bytes32,bytes32,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('country', BYTES_32),
     new EthereumTopic('guildId', INT_32)
    ]);

export const SampleYoutube = new EthereumEventLog(
    'SampledYoutube(bytes32,bytes32,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('videoId', RIGHT_PADDED_BYTES_32),
     new EthereumTopic('guildId', INT_32)
    ]);
 
export const SequenceCreated = new EthereumEventLog(
    'SequenceCreated(address,bytes32,string)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('ipfsHash', IPFS_HASH)],
    new EthereumTopic('title', STRING));

export const SampleCreated = new EthereumEventLog(
    'SampleCreated(address,bytes32,string,uint32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('guildId', INT_32)
    ],
    new EthereumTopic('title', STRING),
);

export const NewNoteSequence = new EthereumEventLog(
    'NewNoteSequence(bytes32,bytes32)',
    [new EthereumTopic('sampleHash', IPFS_HASH),
     new EthereumTopic('noteSequenceHash', IPFS_HASH)]);

export const NewDiscogsSample = new EthereumEventLog(
    'NewDiscogsSample(bytes32,uint256,bytes32,uint32)',
    [new EthereumTopic('sampleHash', IPFS_HASH),
     new EthereumTopic('coverArtHash', IPFS_HASH),
     new EthereumTopic('guildId', INT_32)
    ],
     new EthereumTopic('discogsId', UINT_256),
);

export const NewNoteSequenceAggregation = new EthereumEventLog(
    'NewNotesAggregation(bytes32,bytes32,bytes32,uint32,uint32,bytes32)',
    [new EthereumTopic('sampleHash', IPFS_HASH),
     new EthereumTopic('noteA', NOTE_BYTES_32),
     new EthereumTopic('noteB', NOTE_BYTES_32)],
    new EthereumTopic('startTime', INT_32),
    new EthereumTopic('endTime', INT_32),
    new EthereumTopic('remainingNotes', NOTES_BYTES_32));

export const SampleFavorited = new EthereumEventLog(
    'SampleFavorited(address,bytes32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('sampleHash', IPFS_HASH)]);

export const SampleUnfavorited = new EthereumEventLog(
    'SampleUnfavorited(address,bytes32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('sampleHash', IPFS_HASH)]);

export const SequenceEdited = new EthereumEventLog(
    'SequenceEdited(address,bytes32,bytes32,bytes32,string)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('previousSequence', IPFS_HASH),
     new EthereumTopic('newSequence', IPFS_HASH)],
    new EthereumTopic('diff', IPFS_HASH),
    new EthereumTopic('title', STRING),
    );

export const TokenizedSequenceEdited = new EthereumEventLog(
    'SequenceEdited(address,bytes32,bytes32,string,uint32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('previousSequence', IPFS_HASH),
     new EthereumTopic('newSequence', IPFS_HASH)],
    new EthereumTopic('title', STRING),
    new EthereumTopic('bpm', INT_32),
    );


export const PresetTag = new EthereumEventLog(
    'PresetTagged(address,bytes32,bytes32,uint32)',
    [new EthereumTopic('contentHash', IPFS_HASH),
     new EthereumTopic('tag', BYTES_32),
     new EthereumTopic('guildId', INT_32),
    ],
    new EthereumTopic('user', ADDRESS),
);

export const NewGuild = new EthereumEventLog(
    'NewGuild(address,uint32,string)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('guildId', INT_32)],
    new EthereumTopic('name', STRING),
);

//event NewGuildMemberRequest(address indexed, address indexed, uint256 indexed);
export const NewGuildMemberRequest = new EthereumEventLog(
    'NewGuildMemberRequest(address,address,uint32)',
    [new EthereumTopic('requester', ADDRESS),
     new EthereumTopic('newMember', ADDRESS),
     new EthereumTopic('guildId', INT_32)]);

// event NewGuildMemberRequestAccepted(address indexed, uint256 indexed);
export const NewGuildMemberRequestAccepted = new EthereumEventLog(
    'NewGuildMemberRequestAccepted(address,uint32)',
    [new EthereumTopic('newMember', ADDRESS),
     new EthereumTopic('guildId', INT_32)]);

// event NewGuildMemberRequestRejected(address indexed, uint256 indexed);
export const NewGuildMemberRequestRejected = new EthereumEventLog(
    'NewGuildMemberRequestRejected(address,uint32)',
    [new EthereumTopic('newMember', ADDRESS),
     new EthereumTopic('guildId', INT_32)]);

// event NewGuildMemberRequestRejected(address indexed, uint256 indexed);
export const GuildKeyEncrypted = new EthereumEventLog(
    'GuildKeyEncrypted(address,uint32,bytes32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('guildId', INT_32),
     new EthereumTopic('ipfsHash',IPFS_HASH)]);

export const NewEncryptedContent = new EthereumEventLog(
    'NewEncryptedContent(address,bytes32,bytes32,int8,bytes32,bytes32[9],bytes32[6])',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('newContent', IPFS_HASH),
     new EthereumTopic('contentType', INT_8),
    ],
     new EthereumTopic('previousContent', IPFS_HASH),
    new EthereumTopic('encryptedName', BYTES_32_ENCRYPTED),
    new EthereumTopic('encryptedContentKey', BYTES_32_ARRAY(9), 9),
    new EthereumTopic('publicKey', BYTES_32_ARRAY(6), 6),
    );

export const EncryptedContentShared = new EthereumEventLog(
    'EncryptedContentShared(address,address,bytes32,bytes32[9],bytes32[6])',
    [new EthereumTopic('sharedWith', ADDRESS),
     new EthereumTopic('creator', ADDRESS),
     new EthereumTopic('contentHash', IPFS_HASH),
    ],
    new EthereumTopic('encryptedContentKey', BYTES_32_ARRAY(9), 9),
    new EthereumTopic('publicKey', BYTES_32_ARRAY(6), 6),
    );


export const NewPublicKey = new EthereumEventLog(
    'NewPublicKey(address,bytes32[6])',
    [new EthereumTopic('user', ADDRESS),
    ],
    new EthereumTopic('publicKey', BYTES_32_ARRAY(6), 6),
    );

export const NewPreset2 = new EthereumEventLog(
    'NewPreset(address,bytes32,uint32,bytes32,bytes32[9],bytes32[6])',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('contentHash', IPFS_HASH),
     new EthereumTopic('guildId', INT_32)
    ],
    new EthereumTopic('encryptedName', BYTES_32_ENCRYPTED),
    new EthereumTopic('encryptedContentKey', BYTES_32_ARRAY(9), 9),
    new EthereumTopic('publicKey', BYTES_32_ARRAY(6), 6),
    );

export const PresetSample = new EthereumEventLog(
    'PresetSample(bytes32,bytes32,uint32)',
    [
        new EthereumTopic('contentHash', IPFS_HASH),
        new EthereumTopic('sampleHash', IPFS_HASH),
        new EthereumTopic('guildId', INT_32)
    ],
    );

export const PresetInstrumentType = new EthereumEventLog(
    'PresetInstrumentType(bytes32,bytes32,uint32)',
    [
        new EthereumTopic('contentHash', IPFS_HASH),
        new EthereumTopic('instrumentType', BYTES_32_LEFT),
        new EthereumTopic('guildId', INT_32)
    ],
    );

export const NewMonthlyIndex = new EthereumEventLog(
    'NewMonthlyIndex(bytes32,uint32,uint64)',
    [
     new EthereumTopic('month', UINT_256),
     new EthereumTopic('year', UINT_256)
    ],
     new EthereumTopic('hash', IPFS_HASH)
    );

export const New2DMapping = new EthereumEventLog(
    'New2DMapping(bytes32)',
    [
     new EthereumTopic('ipfsHash', IPFS_HASH)
    ],

    );

export const PublicMessageSent = new EthereumEventLog(
    'PublicMessageSent(address,address,bytes32,bytes32)',
    [
        new EthereumTopic('fromUser', ADDRESS),
        new EthereumTopic('toUser', ADDRESS),
        new EthereumTopic('referenceHash', IPFS_HASH),
    ],
    new EthereumTopic('messageHash', IPFS_HASH),
    );

export const SampleCopyStrike = new EthereumEventLog(
    'SampleCopyStrike(address,bytes32,bytes32)',
    [
        new EthereumTopic('user', ADDRESS),
        new EthereumTopic('sampleHash', IPFS_HASH),
        new EthereumTopic('referenceHash', IPFS_HASH),
    ]
    );

export const SampleTakenDown = new EthereumEventLog(
    'SampleTakenDown(bytes32)',
    [
        new EthereumTopic('sampleHash', IPFS_HASH),
    ]
    );

export const FoldersUpdated = new EthereumEventLog(
    'FoldersUpdated(address,bytes32)',
    [
        new EthereumTopic('user', ADDRESS),
        new EthereumTopic('foldersHash', IPFS_HASH),
    ]
    );

export const NewIndex = new EthereumEventLog(
    'NewIndex(uint32,bytes32)',
    [
        new EthereumTopic('guildId', INT_32),
    ],
    new EthereumTopic('indexHash', IPFS_HASH),
    );

export const NewGuildSequence = new EthereumEventLog(
    'NewGuildSequence(address,bytes32,uint32,bytes32,bytes32,bytes32[9],bytes32[6])',
    [
        new EthereumTopic('user', ADDRESS),
        new EthereumTopic('contentHash', IPFS_HASH),
        new EthereumTopic('guildId', INT_32),
    ],
    new EthereumTopic('previousHash', IPFS_HASH),
    new EthereumTopic('encryptedName', BYTES_32_ENCRYPTED),
    new EthereumTopic('encryptedContentKey', BYTES_32_ARRAY(9), 9),
    new EthereumTopic('publicKey', BYTES_32_ARRAY(6), 6),
    );

export const NewGuildClassification = new EthereumEventLog(
    'NewGuildClassification(uint32,bytes32)',
    [
        new EthereumTopic('guildId', INT_32),
        new EthereumTopic('contentHash', IPFS_HASH),
    ]);;

 export const Transfer = new EthereumEventLog(
    'Transfer(address,address,uint256)',
    [
        new EthereumTopic('fromUser', ADDRESS),
        new EthereumTopic('toUser', ADDRESS),
    ],
     new EthereumTopic('amount', INT_32 ),
 );;

export const SequenceTagged= new EthereumEventLog(
    'SequenceTagged(bytes32,bytes32,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('tag', BYTES_32),
     new EthereumTopic('guildId', INT_32)
    ]);

export const SequenceFavorited = new EthereumEventLog(
    'SequenceFavorited(bytes32,address,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('user', ADDRESS),
     new EthereumTopic('guildId', INT_32)
    ]);

export const SequenceStarred = new EthereumEventLog(
    'SequenceStarred(bytes32,address,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('user', ADDRESS),
     new EthereumTopic('guildId', INT_32)
    ]);

export const SequenceUnfavorited = new EthereumEventLog(
    'SequenceUnfavorited(bytes32,address,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('user', ADDRESS),
     new EthereumTopic('guildId', INT_32)
    ]);


export const SequenceUnstarred = new EthereumEventLog(
    'SequenceUnstarred(bytes32,address,uint32)',
    [new EthereumTopic('ipfsHash', IPFS_HASH),
     new EthereumTopic('user', ADDRESS),
     new EthereumTopic('guildId', INT_32)
    ]);


export const NewDataType = new EthereumEventLog(
    'NewDataType(bytes32,string)',
    [new EthereumTopic('dataType', BYTES_32),
    ],
    new EthereumTopic('description', STRING));

export const NewLinkType = new EthereumEventLog(
    'NewLinkType(bytes32,string)',
    [new EthereumTopic('linkType', BYTES_32),
    ],
    new EthereumTopic('description', STRING));

export const NewAnnotationType = new EthereumEventLog(
    'NewAnnotationType(bytes32,string)',
    [new EthereumTopic('annotationType', BYTES_32),
    ],
    new EthereumTopic('description', STRING));

export const NewAnnotation = new EthereumEventLog(
    'NewAnnotation(bytes32,bytes32,bytes32,address)',
    [
        new EthereumTopic('annotationType', BYTES_32),
        new EthereumTopic('data', IPFS_HASH),
        new EthereumTopic('address', ADDRESS),
    ],
    new EthereumTopic('annotationData', BYTES_32),
);

export const NewLink = new EthereumEventLog(
    'NewLink(bytes32,bytes32,bytes32,address)',
    [new EthereumTopic('linkType', BYTES_32),
     new EthereumTopic('fromData', IPFS_HASH),
     new EthereumTopic('toData', IPFS_HASH),
    ],
     new EthereumTopic('address', ADDRESS),
    );

export const NewMix= new EthereumEventLog(
    'NewMix(address,bytes32,bytes32,string,uint32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('mixHash', IPFS_HASH),
     new EthereumTopic('previousHash', IPFS_HASH),
    ],
     new EthereumTopic('title', STRING),
     new EthereumTopic('guildId', INT_32),
    );

export const NewEffect = new EthereumEventLog(
    'NewEffect(address,bytes32,bytes32,string,uint32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('effectHash', IPFS_HASH),
     new EthereumTopic('effectType', BYTES_32),
    ],
     new EthereumTopic('title', STRING),
     new EthereumTopic('guildId', INT_32),
    );

export const ReleaseInfo = new EthereumEventLog(
    'ReleaseInfo(bytes32,uint32,string,bytes32,bytes32)',
    [new EthereumTopic('artistName', BYTES_32),
     new EthereumTopic('releaseId', INT_32),
    ],
     new EthereumTopic('releaseName', STRING),
     new EthereumTopic('coverArtHash', IPFS_HASH),
     new EthereumTopic('releaseType', BYTES_32),
    );

export const SampleByArtist = new EthereumEventLog(
    'SampleByArtist(bytes32,bytes32)',
    [new EthereumTopic('artistName', BYTES_32),
     new EthereumTopic('ipfsHash', IPFS_HASH),
     ]
    );

export const ArtistInfo = new EthereumEventLog(
    'ArtistInfo(bytes32,bytes32,string)',
    [new EthereumTopic('artistName', BYTES_32),
     new EthereumTopic('linkType', BYTES_32),
    ],
     new EthereumTopic('link', STRING),
    );

export const MidiCCParameter = new EthereumEventLog(
    'MidiCCParameter(bytes32,uint32,bytes32,address)',
    [new EthereumTopic('deviceName', BYTES_32),
     new EthereumTopic('ccNumber', INT_32),
     new EthereumTopic('parameterName', BYTES_32),
    ],
     new EthereumTopic('user', ADDRESS),
    );

export const SampleInSequence = new EthereumEventLog(
    'SampleInSequence(bytes32,bytes32)',
    [new EthereumTopic('sequenceHash', IPFS_HASH),
     new EthereumTopic('sampleHash', IPFS_HASH)
    ]
    );

export const ListEdited = new EthereumEventLog(
    'ListEdited(bytes32,bytes32,address,bytes32,uint32)',
    [new EthereumTopic('newContent', IPFS_HASH),
     new EthereumTopic('previousContent', IPFS_HASH),
     new EthereumTopic('user', ADDRESS),
    ],
    new EthereumTopic('title', BYTES_32),
    new EthereumTopic('guildId', INT_32),
    );

export const ListHighlighted = new EthereumEventLog(
    'ListHighlighted(bytes32,address)',
    [new EthereumTopic('contentHash', IPFS_HASH),
    ],
    new EthereumTopic('user', ADDRESS)
    );

export const ListUnhighlighted = new EthereumEventLog(
    'ListUnhighlighted(bytes32,address)',
    [new EthereumTopic('contentHash', IPFS_HASH),
    ],
    new EthereumTopic('user', ADDRESS)
    );

export const ListFavorited = new EthereumEventLog(
    'ListFavorited(bytes32,address)',
    [new EthereumTopic('contentHash', IPFS_HASH),
    ],
    new EthereumTopic('user', ADDRESS)
    );

export const ListUnfavorited = new EthereumEventLog(
    'ListUnfavorited(bytes32,address)',
    [new EthereumTopic('contentHash', IPFS_HASH),
    ],
    new EthereumTopic('user', ADDRESS)
    );

export const ListDeleted = new EthereumEventLog(
    'ListDeleted(bytes32,address)',
    [new EthereumTopic('contentHash', IPFS_HASH),
    new EthereumTopic('user', ADDRESS)
    ],
    );

export const NewWallpaper = new EthereumEventLog(
    'NewWallpaper(address,bytes32,bytes32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('wallpaperHash', IPFS_HASH),
     new EthereumTopic('thumbnailHash', IPFS_HASH)
    ]);

export const DefaultWallpaper = new EthereumEventLog(
    'DefaultWallpaper(address,bytes32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('wallpaperHash', IPFS_HASH)
    ]);

export const NewPack = new EthereumEventLog(
    'NewPack(address,bytes32,bytes32,bytes32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('packHash', IPFS_HASH),
     new EthereumTopic('previousHash', IPFS_HASH)
    ],
     new EthereumTopic('title', BYTES_32)
);

export const PackHasContent = new EthereumEventLog(
    'PackHasContent(bytes32,bytes32)',
    [new EthereumTopic('packHash', IPFS_HASH),
     new EthereumTopic('contentHash', IPFS_HASH),
    ],
);

export const UserLeftGuild = new EthereumEventLog(
    'UserLeftGuild(uint256,address)',[
     new EthereumTopic('guildId', INT_32),
    ],
    new EthereumTopic('user', ADDRESS),
);

export const NewScript = new EthereumEventLog(
    'NewScript(address,bytes32,bytes32,bytes32)',
    [new EthereumTopic('user', ADDRESS),
     new EthereumTopic('scriptHash', IPFS_HASH),
     new EthereumTopic('scriptType', BYTES_32)
    ],
     new EthereumTopic('title', BYTES_32)
);

export const NewCreatorProject = new EthereumEventLog(
    'NewCreatorProject(address,uint256,bytes32,uint256,string)',
    [
        new EthereumTopic('creator', ADDRESS),
        new EthereumTopic('projectId', UINT_256),
        new EthereumTopic('contentHash', IPFS_HASH)
    ],
    new EthereumTopic('maxInvocations', UINT_256),
    new EthereumTopic('title', STRING)
);

export const NewTokenSeed = new EthereumEventLog(
    'NewTokenSeed(uint256,uint256,bytes32)',
    [
        new EthereumTopic('projectId', UINT_256),
        new EthereumTopic('tokenId', UINT_256)
    ],
    new EthereumTopic('seedHash', BYTES_32)
);

export const ZoraProject = new EthereumEventLog(
    'ZoraProject(bytes32,uint256)',
    [
        new EthereumTopic('projectHash', IPFS_HASH),
        new EthereumTopic('zoraId', UINT_256)
    ]);

export const AccountAuthorized = new EthereumEventLog(
    'AccountAuthorized(address,address,string,uint8,bytes32,bytes32)',
    [
        new EthereumTopic('zequencerAddress', ADDRESS),
        new EthereumTopic('walletAddress', ADDRESS),
    ],
    new EthereumTopic('message', STRING),
    new EthereumTopic('v', INT_8),
    new EthereumTopic('r', BYTES_32_ENCRYPTED),
    new EthereumTopic('s', BYTES_32_ENCRYPTED)
);

export const PluginCreated = new EthereumEventLog(
    'PluginCreated(uint256,address,string)',
    [
        new EthereumTopic("tokenId", UINT_256),
        new EthereumTopic("creator", ADDRESS),
    ],
    new EthereumTopic("name", STRING)
);

export const NewPluginVersion = new EthereumEventLog(
    'NewPluginVersion(uint256,uint256,bytes32,string)',
    [
        new EthereumTopic("tokenId", UINT_256),
        new EthereumTopic("versionNumber", UINT_256),
    ],
    new EthereumTopic("pluginContentHash", IPFS_HASH),
    new EthereumTopic("pluginMetadataURI", STRING)
);

export const ProjectHasArrangement = new EthereumEventLog(
    'ProjectHasArrangement(bytes32)',
    [
    ],
    new EthereumTopic("projectHash", IPFS_HASH),
);

export const ProjectBPM = new EthereumEventLog(
    'ProjectBPM(bytes32,int16)',
    [
    ],
    new EthereumTopic("projectHash", IPFS_HASH),
    new EthereumTopic("bpm", UINT_256),
);

export const ProjectVisuals = new EthereumEventLog(
    'ProjectVisuals(bytes32,bytes32)',
    [
    ],
    new EthereumTopic("projectHash", IPFS_HASH),
    new EthereumTopic("thumbnailhash", IPFS_HASH),
);

export const ProjectUsesPreset = new EthereumEventLog(
    'ProjectUsesPreset(bytes32,bytes32)',
    [
    ],
    new EthereumTopic("projectHash", IPFS_HASH),
    new EthereumTopic("presetHash", IPFS_HASH),
);

export const ProjectPatternsCount = new EthereumEventLog(
    'ProjectPatternsCount(bytes32,int8)',
    [
    ],
    new EthereumTopic("projectHash", IPFS_HASH),
    new EthereumTopic("patterns", UINT_256),
);

export const NewSporeCreated = new EthereumEventLog(
    'NewSporeCreated(uint256,uint256,address,address,bytes32)',
    [
    ],
    new EthereumTopic("sporeId", UINT_256),
    new EthereumTopic("tokenId", UINT_256),
    new EthereumTopic("proxy", ADDRESS),
    new EthereumTopic("creator", ADDRESS),
    new EthereumTopic("sporeHash", IPFS_HASH),
);


